export default __webpack_public_path__ + "static/media/dynamic_flex.2107cf0f.jpg";